import { render, staticRenderFns } from "./WcLoadersHeadingAvatar.vue?vue&type=template&id=9d669938&lang=pug&"
import script from "./WcLoadersHeadingAvatar.vue?vue&type=script&lang=js&"
export * from "./WcLoadersHeadingAvatar.vue?vue&type=script&lang=js&"
import style0 from "./WcLoadersHeadingAvatar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports